import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { MEDIA_SIZES } from 'aria-viewer/tour/constants'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import MediaThumbContainer from '../containers/mediaThumbContainer'
import { showSupplementalMediaView, showSupplementalMediaPreview } from '../supplementalMediaActions'
import styleguide from 'aria-viewer/tour/constants/styleGuide'
import Icon from 'aria-viewer/tour/components/icon'
import colors from 'aria-viewer/tour/constants/style/colors'
import { forceMediaPause } from 'aria-viewer/interactive-element/actions/common.js'

const transitions = [
    [
        { transition: 'opacity 300ms linear 200ms' },
        { transition: 'opacity 300ms linear 100ms' },
        { transition: 'opacity 300ms linear 0s' },
    ],
    { transition: 'opacity 300ms linear 400ms' },
]

class SupplementalMediaInlineView extends PureComponent {
    constructor(props) {
        super(props)

        this.onMouseLeave = this.onMouseLeave.bind(this)
        this.handleOnClick = this.handleOnClick.bind(this)
        this.handleOnSeeAllClick = this.handleOnSeeAllClick.bind(this)
        this.getAllButton = this.getAllButton.bind(this)
    }

    handleOnClick(e, media) {
        const { showSupplementalMediaView, supplementalMediaPreviewVisible, forceMediaPause } = this.props
        if (supplementalMediaPreviewVisible) {
            showSupplementalMediaView({
                stopid: media.stopid,
                media,
            })
            forceMediaPause(true)
        }
    }

    handleOnSeeAllClick() {
        const { showSupplementalMediaView, currentStop, supplementalMediaPreviewVisible } = this.props
        if (supplementalMediaPreviewVisible) {
            showSupplementalMediaView({
                stopid: currentStop.stopid,
                media: {},
            })
        }
    }

    onMouseLeave() {
        //set timeout to prevent race condition from the animation
        clearTimeout(this.mouseLeave)

        this.mouseLeave = setTimeout(() => {
            this.props.showSupplementalMediaPreview(false)
        }, 100)
    }

    getAllButton(nextProps) {
        const { supplementalMediaPreviewVisible, largeScreen } = nextProps

        return (
            <div
                onClick={this.handleOnSeeAllClick}
                style={{
                    cursor: 'pointer',
                    width: 70,
                    height: 20,
                    position: 'absolute',
                    right: 0,
                    top: largeScreen ? -25 : -20,
                    ...transitions[1],
                    opacity: supplementalMediaPreviewVisible ? 1 : 0,
                }}
            >
                <div
                    style={{
                        display: 'inline-block',
                        color: colors.white,
                        fontSize: 16,
                        textShadow: '0 2px 4px rgba(0,0,0,0.5)',
                    }}
                >
                    View All
                    <div
                        style={{
                            width: 12,
                            height: 7,
                            position: 'absolute',
                            bottom: largeScreen ? 4.5 : 8,
                            right: 0,
                            transform: 'rotate(270deg)',
                        }}
                    >
                        <Icon icon="arrowDown" />
                    </div>
                </div>
            </div>
        )
    }

    init(props, nextProps) {
        if (nextProps) {
            const {
                width,
                height,
                index,
                supplementalMediaCarouselMediasLength: { mediaCount },
                supplementalMediaCarousel,
            } = nextProps
            const length = mediaCount < 3 ? mediaCount + 1 : 4 //add 1 since we main media won't be included
            const { medias } = supplementalMediaCarousel.get(index) || []
            this.media =
                mediaCount == 0
                    ? []
                    : Array.from({ length: length }, (_, ii) => {
                          return (
                              <MediaThumbContainer
                                  key={ii}
                                  width={width}
                                  height={height}
                                  size={MEDIA_SIZES.thumb}
                                  index={index}
                                  mediaIndex={ii}
                                  media={medias[ii]}
                                  onClick={this.handleOnClick}
                                  showOverlay={false}
                                  thumbStyle={{
                                      boxShadow: '0 4px 10px 0 rgba(0,0,0,0.5)',
                                  }}
                                  style={{
                                      transform: 'translateZ(1px)',
                                      cursor: 'pointer',
                                      display: 'inline-block',
                                      padding: '0 5px',
                                      ...transitions[0][
                                          nextProps.supplementalMediaPreviewVisible
                                              ? ii - 1
                                              : transitions[0].length - ii
                                      ],
                                      opacity: nextProps.supplementalMediaPreviewVisible ? 1 : 0,
                                  }}
                              />
                          )
                      })

            //this will remove main media from the list as it will always be index 0
            this.media.shift()

            this.allButton = null //Temporarily disable View All // this.media.length >= 3 ? this.getAllButton(nextProps) : null;
        }
        if (nextProps) {
            this.DivStyle = {
                pointerEvents: nextProps.supplementalMediaPreviewVisible ? 'auto' : 'none',
                display: 'inline-block',
                position: 'absolute',
                left: nextProps.pictureSizes.width,
                top: nextProps.pictureSizes.height,
                height: nextProps.height,
                transform: 'translate(-100%, -100%)',
                zIndex: nextProps.supplementalMediaPreviewVisible ? 7 : 3,
            }
        }
    }

    componentWillMount() {
        this.init(null, this.props)
    }
    componentWillReceiveProps(nextProps) {
        this.init(this.props, nextProps)
    }

    render() {
        return (
            <div style={this.DivStyle} onMouseLeave={this.onMouseLeave}>
                {this.allButton}
                {this.media}
            </div>
        )
    }
}

export default connect(
    mapSelectorsToProps([
        'supplementalMediaPreviewVisible',
        'currentStop',
        'supplementalMediaCarouselMediasLength',
        'languages',
        'supplementalMediaCarousel',
    ]),
    {
        showSupplementalMediaView,
        showSupplementalMediaPreview,
        forceMediaPause,
    }
)(SupplementalMediaInlineView)
